import { cubicBezier, motion } from 'motion/react';

export const Curve = () => {
  const initialPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q-100 ${
    window.innerHeight / 2
  } 100 0`;
  const targetPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q100 ${
    window.innerHeight / 2
  } 100 0`;

  const curve = {
    initial: {
      d: initialPath,
    },
    enter: {
      d: targetPath,
      transition: { duration: 1, ease: cubicBezier(0.76, 0, 0.24, 1) },
    },
    exit: {
      d: initialPath,
      transition: { duration: 0.8, ease: cubicBezier(0.76, 0, 0.24, 1) },
    },
  };

  return (
    <svg className="absolute left-[-95px] top-0 h-full w-24 fill-[#f7e7ce] stroke-none dark:fill-[#011322]">
      <motion.path variants={curve} initial="initial" animate="enter" exit="exit" />
    </svg>
  );
};
